import { AmmunitionStockResolverBase } from './ammunition-stock.resolver.base';
import { AmmunitionStockService } from './ammunition-stock.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class AmmunitionStockResolver extends AmmunitionStockResolverBase {

  constructor(protected service: AmmunitionStockService) {
    super(service);
  }
}



